/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Loader CSS component
 *
 * Use any css style (css format)
 *
 * You can use three span as children. Set display: 'block' for each.
 *
 * Example:
 * span:nth-child(1) {
 * display: block;
 * }
 *
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.4.0
 */

export const customizeStyle = '';
